import { FC } from "react";
import { useNavigate } from "react-router";

import { LinkButton, Tooltip, useDrawer } from "@digital-services/ui";

interface Props {
  organizationId: string;
  organizationName?: string | null;
  isTextBold?: boolean; // Bold text is needed for Hyperlink as value in Drawer's right "value" section
}

export const OrganizationLink: FC<Props> = props => {
  const { organizationId, organizationName, isTextBold = false } = props;
  const { hideDrawer } = useDrawer();
  const navigate = useNavigate();

  const onClick = () => {
    hideDrawer(); // to be renamed after migration to `@digital-services/ui`
    navigate(`/organizations/${organizationId}`);
  };

  return (
    <span className={`inline ${isTextBold ? "font-bold" : ""}`}>
      {organizationName ? (
        <LinkButton data-testid="organization-link-button" onClick={onClick}>
          <Tooltip message={"Go to organization"}>{organizationName}</Tooltip>
        </LinkButton>
      ) : (
        "N/A"
      )}
    </span>
  );
};
